import { useEffect, useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetAllcompanyQuery } from "../../../../store/api/itemtaxapi"
const Tab1 = ({ handleChange, setFormData, formdata }) => {
  const [companys, setCompanys] = useState([])
  const { data: companydata, isLoading, isError } = useGetAllcompanyQuery()
  const gstOptions = [{ "name": "Taxable" }, { "name": "Nil-Rated" }, { "name": "Exmpted" }, { "name": "Non-GST" }]

  useEffect(() => {
    if (companydata) {
      setCompanys(companydata.data)
    }
  }, [companydata])

  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>
      <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <Input
              name="title"
              value={formdata.title}
              onChange={handleChange}
              label="Title"
              style={{ height: "30px" }}
            />
          </div>
        </div>
        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <SelectSearch
              list={gstOptions}
              label="GST Treatment "
              value={formdata.gst_treatment}
              onChange={(val) =>
                setFormData((prev) => ({
                  ...prev,
                  gst_treatment: val,
                }))
              }
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              placeholder=""
            />
          </div>
        </div>
        {formdata.gst_treatment == 'Taxable' && (
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <Input
                name="gst_rate"
                type='number'
                value={formdata.gst_rate}
                label="GST Rate"
                onChange={handleChange}
                style={{ height: "30px" }}
              />

            </div>
          </div>)}
        <div style={{ flex: '1' }}>
          <SelectSearch
            list={companys || []}
            label="Company"
            value={formdata.company}
            onChange={(val) =>
              setFormData((prev) => ({
                ...prev,
                company: val,
              }))
            }
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            placeholder=""
          />
        </div>
      </div>
    </div>
  )
}

export default Tab1